import { IonRouterOutlet, IonTabBar, IonTabs, IonTabButton } from '@ionic/react';
import { search } from 'ionicons/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, useHistory, useParams } from 'react-router-dom';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import Check from '@pages/Check';
import { CheckType } from '@pages/Check/Enums';
import { generateRoute } from '@services/navigation-service';
import { getSearchEmailEnabled } from '@state/event';

import { Icon, Label } from '../Event/Tabs';

enum Tabs {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Check = 'check',
  Search = 'search',
}

const EventTabs = () => {
  const history = useHistory();
  const { eventId } = useParams<{ eventId: string }>();
  const searchEmailEnabled = useSelector(getSearchEmailEnabled);
  /*
     IonTabButton has href navigation and it's not closing the camera.
     Only solution seems to be to watch the tab change and do a history.replace to unmount the camera on navigation.
    */
  const onIonTabsDidChange = ({ detail: { tab } }: CustomEvent<{ tab: string }>) => {
    if (tab === Tabs.Search) {
      history.replace(generateRoute(RoutePath.KioskCheckBySearch, { eventId }));
    }
  };

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route
          path={generateRoute(RoutePath.KioskCheckBySearch)}
          exact
          render={() => <Check type={CheckType.Manual} />}
        />
      </IonRouterOutlet>
      {/* styled(IonTabBar) results in IonTabs error, so use inline styles here */}
      <IonTabBar
        slot="bottom"
        style={searchEmailEnabled ? { display: 'flex' } : { display: 'none' }}
        // skipcq: JS-0417
        onIonTabsDidChange={onIonTabsDidChange}
      >
        <IonTabButton
          tab={Tabs.Search}
          href={generateRoute(RoutePath.KioskCheckBySearch, { eventId })}
        >
          <Icon icon={search} />
          <Label>{t`Search`}</Label>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default EventTabs;
